import { Inject, Injectable } from '@angular/core';
import { TranslateService as NgxTranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FavieTranslateService {
  constructor(
    @Inject(NgxTranslateService) private translate: NgxTranslateService
  ) {}

  public initLanguage(): Promise<any> {
    return new Promise((resolve: any) => {
      this.translate.setDefaultLang(environment.defaultLanguage);
      this.translate.use(environment.defaultLanguage).subscribe((lang) => {
        resolve();
      });
    });
  }
}
